import { useErrorContext } from '../../context/ErrorContext';
import Validation from '../../validation/Authentication/Validation.js';
import { Axios, useState, useNavigate, FaEyeSlash, useParams } from '../../common/common';
import Navigations from '../../common/useNavigation.js';
import { useEffect } from 'react';
import { showToast } from '../../Utils/toastUtils.js';

const MidResetPassword = () => {
    const { token } = useParams();
    const { navigateRegisteration, navigateMain, navigateOTP, navigateSellerProductAttributes, navigateUserType, navigateDashboard, navigateBuyerBusinessdetails } = Navigations();
    const navigate = useNavigate();
    const { validateResetPasswordForm } = Validation;
    const { setValidationError, clearAllErrors } = useErrorContext();

    const [type, setType] = useState('password');
    const [icon, setIcon] = useState(FaEyeSlash);

    const [values, setValue] = useState({ passWord: "", confirmpassWord: "" });
    const [isLoading, setisLoading] = useState(false);
    const [isDisabled, setisDisabled] = useState(false);
    const navigateSellerPersonaldetails = (type) => { navigate(`/Business-details/${type}`); };
    const navigateResetPassword = (token) => { navigate(`/reset-password/${token}`); };


    useEffect(() => {
        showToast('', '');
    }, [])

    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateResetPasswordForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };

    const handleChange = e => {
        const { name, value } = e.target;
        setValue(prev => ({ ...prev, [name]: value }));
        const validationErrors = validateAndSetErrors(values);
        if (Object.keys(validationErrors).length === 0) {
            clearAllErrors();
        }
    };
    const handleSubmit = e => {
        e.preventDefault();
        const validationErrors = validateAndSetErrors(values);
        if (Object.keys(validationErrors).length === 0) {

            clearAllErrors();
            checkResetPassword();
        }
    };
    const navigateRegisterations = () => {
        setisLoading(true);
        navigateRegisteration();
    }
    const checkResetPassword = () => {
        const { passWord, confirmpassWord } = values;


        if (!passWord && !confirmpassWord) {
            showToast('Please fill required field Password and ConfirmPassword', 'error');
            return;
        }

        setisLoading(true);
        setisDisabled(true);

        if (passWord === confirmpassWord) {
            Axios.post(`${process.env.REACT_APP_API_URL}/api/ResetPassword`, { Password: passWord, ConfirmPassWord: confirmpassWord, token: token, app: 0 }, { withCredentials: true })
                .then(handleResetPasswordResponse)
                .catch(handleResetPasswordError);
        }
        else {
            setisLoading(false);
            setisDisabled(false);
            showToast('Password and ConfirmPassword are not same! Please Check', 'error');
        }



    };

    const handleResetPasswordResponse = (res) => {
        const result = res.data;
        if (result.success === 1) {
            showToast(result.message, 'success');
            setTimeout(() => {
                navigateMain();
            }, 3000);
        }
        else {
            showToast(result.message, 'error');
        }

        resetLoadingState();
    };

    const handleResetPasswordError = (err) => {
        // console.error(err);
        showToast(err.response?.data?.message || err.message || "An error occurred", 'error');
        resetLoadingState();
    };
    const resetLoadingState = () => {
        setisLoading(false);
        setisDisabled(false);
    };

    const clearForm = () => {
        values.emailnmobi = '';
    };

    const handleToggle = () => {
        if (type === 'password') { setType('text'); }
        else { setType('password'); }
    }

    return { handleSubmit, handleChange, values, type, setType, icon, setIcon, handleToggle, isLoading, setisLoading, isDisabled, setisDisabled, useErrorContext, navigateRegisterations };
};

export default MidResetPassword;
